import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import useMaxReportModal from '../hooks/useMaxReportModal';
import HeaderText from '../../../../shared/components/HeaderText/HeaderText';
import { BoxShadow } from '../../../../shared/GlobalStyles';
import ReportingModal from '../ReportingModal';
import MaxReportData from './MaxReportData';
import ActiveReportSidebar from '../ActiveReportSidebar';

const MainContainer = styled('main')`
  display: flex;
  flex: ${(props) => (props.isReportOpen ? 50 : 10)};
  flex-direction: column;
  overflow: auto;
  
  @media screen and (max-width: 540px) {
    width: 100%;
    padding: 0px 15px;
    margin: 0px;
  }
`;

const HeaderRow = styled('div')`
  display: flex;
  margin: 30px 30px 40px 30px;

  h1 {
    text-transform: capitalize;
  }

  @media screen and (max-height: 920px) {
    margin-bottom: 20px;
    margin-top: 30px;
  }
`;

const BodyRow = styled('div')`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  flex-basis: 100%;
  min-height: 0;
`;

const MobileActiveMenu = styled('div')`
  position: fixed;
  width: 140px;
  height: 45px;
  bottom: 30px;
  left: 50%;
  margin-left: -70px;
  background-color: white;
  border-radius: 30px;
  display: none;
  box-shadow: ${BoxShadow};
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const MaxReport = ({ handlePrint, printRef }) => {
  const {
    handleSetIsModalOpen,
  } = useMaxReportModal();

  const isReportOpen = useSelector((state) => state.reporting.ui.isReportOpen);
  const activeModal = useSelector((state) => state.reporting.ui.activeModal);

  useEffect(() => {
    handleSetIsModalOpen(true, 'main');
  }, []);

  return (
    <MainContainer
      isReportOpen={isReportOpen || activeModal === 'downloadMaxReport'}
      ref={printRef}
    >
      <ReportingModal />
      {isReportOpen && (
        <>
          <HeaderRow>
            <HeaderText
              fontWeight={300}
              letterSpacing='normal'
            >
              Max Report
            </HeaderText>
          </HeaderRow>
          <BodyRow>
            <MaxReportData />
          </BodyRow>
          <MobileActiveMenu>
            <ActiveReportSidebar download handlePrint={handlePrint} print />
          </MobileActiveMenu>
        </>
      )}
    </MainContainer>
  );
};

MaxReport.propTypes = {
  handlePrint: PropTypes.func,
  printRef: PropTypes.shape({
    current: PropTypes.oneOfType([
      PropTypes.instanceOf(Element),
      PropTypes.oneOf([null]),
    ]),
  }),
};

MaxReport.defaultProps = {
  handlePrint: () => {},
  printRef: null,
};

export default MaxReport;
